import type { NewConfirmationFormData } from "../types/new-confirmation.types";

/** API field names and types. Form keeps internal names; mapping is done here. */
const toApiPayload = (data: NewConfirmationFormData) => ({
  amount: Number(data.monto) || 0,
  bank: data.banco,
  payment_date: data.fecha,
  currency: data.tipoMoneda || undefined,
  notes: data.nota || undefined,
  attachment: data.comprobante,
});

export function buildFormDataForConfirmation(data: NewConfirmationFormData): FormData {
  const formData = new FormData();
  const payload = toApiPayload(data);
  if (payload.amount > 0) {
    formData.append("amount", String(payload.amount));
  }
  if (payload.bank?.trim()) {
    formData.append("bank", payload.bank.trim());
  }
  formData.append("payment_date", payload.payment_date);
  if (payload.currency) formData.append("currency", payload.currency);
  if (payload.notes) formData.append("notes", payload.notes);
  if (payload.attachment) {
    formData.append("attachment", payload.attachment, payload.attachment.name);
  }
  return formData;
}
